import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
// import notify from '../../Notifications/ToastifyActions';
import notify from '../../../Notifications/ToastifyActions';

function UpdateProjectDetailsService(token,data) {
    return axios.post(`${CURRENT_API_URL}/projectsDashboard/updateProjectDetails`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("Project Details has been updated successfully.")
        return res.data; // Correctly return the response data
    }).catch(error => {
        console.error(error);
        notify.NotifyError("An error occurred while updating project details. Please try again later.");
        return false;
    });
}

export  default UpdateProjectDetailsService